import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  standalone: false,
})
export class UserInfoComponent implements OnInit {
  /** First name and last name of the user */
  @Input() userFullName: string;
  /** Email of the user*/
  @Input() email: string;
  /** Phone number of the user*/
  @Input() phone: string;
  /** Indicates if the user is a global admin.*/
  @Input() isGlobalAdmin: boolean;
  /** True when the user has RBAC V2 roles assigned. Used to prefer V2 role descriptions over the legacy V1 display. */
  @Input() hasRbacV2Roles: boolean;
  /** Services enabled for the user's company.
   * It will appear if the user is a global admin.
   */
  @Input() companyEnabledServices: string;
  /** Lenght of the access data */
  @Input() accessDataLength: number;
  /** Enabled services for the user if the user is not a global admin. */
  @Input() joinedAccessData: string;

  constructor() {}

  ngOnInit(): void {}
}
